import React from 'react';
import { Rating } from 'react-simple-star-rating';
import { useReviewPageQueries } from './hooks/useReviewPageQueries';
import { makeBookingManagerApi } from 'services/BookingManagerApi';
import { ParameterService } from 'services/ParametersProviderApi/ParametersService';

interface IReviewSummaryProps {
  hotelUuid?: string;
  className?: string;
}

export const ReviewSummary = ({ hotelUuid, className }: IReviewSummaryProps) => {
  const dynamicParameters = ParameterService.getParameters();
  const { getHotelReviews } = useReviewPageQueries(makeBookingManagerApi(), hotelUuid);
  const reviewData = getHotelReviews.data?.data;


  if (!reviewData?.generalScore || !dynamicParameters.ENABLE_HOTEL_REVIEWS_TEMP) {
    return null;
  }

  return (
    <div className={`review-summary-${hotelUuid} flex items-center gap-10px ${className}`} key={`review-summary-${hotelUuid}`}>
      <span className="score font-pt-sans text-17px text-black font-semibold">{reviewData.generalScore.toFixed(1)}</span>
      <Rating
        size={15}
        initialValue={Math.round((reviewData.generalScore / 5) * 10) / 2}
        transition
        readonly={true}
        allowFraction={true}
        iconsCount={5}
      />
      <a
        className="font-hurmegeometric-sans text-14px underline text-brown-prime cursor-pointer visited:text-brown-prime"
        href={`/reviews/${hotelUuid}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        View Details
      </a>
    </div>
  );
};